import axios from 'axios'

const state = {
    products: [],
    groups: [],
    paymentMethods: [],
    activeTickets: [],
    activeTicket: {},
    restaurantAreas: [],
    restAreaLabels: [],
    token: localStorage.getItem('user-token') || '',
    refreshToken: localStorage.getItem('refresh-token') || '',
    status: '',
    imageLink: '',
    actualTicket: 0,
    loginInfo: {
        user: {
            "username": "",
            "name": ""
        },
        actions:[]
    },
    userActions:[],
    discount_types: []
};

const getters = {
    allRestAreasLabels: (state) => state.restAreaLabels,
    allPaymentMethods: (state) => state.paymentMethods,
    allDiscounts: (state) => state.discount_types,
    allProducts: (state) => state.products,
    allGroups: (state) => state.groups,
    allActiveTickets: (state) => state.activeTickets,
    allRestAreas: (state) => state.restaurantAreas,
    isAuthenticated: state => !!state.token,
    authStatus: state => state.status,
    imgLink: state => state.imageLink,
    activeTicket: state => state.actualTicket,
    loginInfo: state => state.loginInfo,
};

const actions = {
    logout({ commit }) {
        // Call backend logout endpoint if user is authenticated
        const token = localStorage.getItem('user-token')
        if (token) {
            axios.post('/user/logout')
                .catch(err => {
                    console.log('Logout error:', err)
                })
        }

        // Clear tokens and user data
        localStorage.removeItem('user-token')
        localStorage.removeItem('refresh-token')
        localStorage.removeItem('remember-me')
        localStorage.removeItem("login-info")
        delete axios.defaults.headers.common['Authorization']
        commit("LOGOUT")
        return true
    },
    login({ commit }, loginData) {
        // loginData puede ser { username, password } o { username, password, remember_me }
        const user = {
            username: loginData.username,
            password: loginData.password
        }
        const rememberMe = loginData.remember_me || false

        return new Promise((resolve, reject) => { // The Promise used for router redirect in login
            commit("AUTH_REQUEST")
            axios({ url: '/user/login', data: user, method: 'POST' })
                .then(resp => {
                    const token = resp.data.access_token
                    const refreshToken = resp.data.refresh_token

                    // Siempre guardar access token
                    localStorage.setItem('user-token', token)
                    axios.defaults.headers.common['Authorization'] = "Bearer " + token
                    commit("AUTH_SUCCESS", token)

                    // Solo guardar refresh token si remember_me está activado
                    if (rememberMe) {
                        localStorage.setItem('refresh-token', refreshToken)
                        localStorage.setItem('remember-me', 'true')
                        commit("SET_REFRESH_TOKEN", refreshToken)
                    } else {
                        // Si no está activado, no guardar refresh token
                        localStorage.removeItem('refresh-token')
                        localStorage.removeItem('remember-me')
                    }

                    localStorage.setItem("login-info", JSON.stringify(resp.data))
                    let loginInfo=resp.data
                    axios.get('/user/'+loginInfo.user.id+"/actions")
                    .then(resp=>{
                        loginInfo.actions=resp.data
                        commit("SET_LOGININFO", loginInfo)
                    }).catch(err=>{
                        console.log(err)
                        commit("SET_LOGININFO", loginInfo)
                    })

                    // you have your token, now log in your user :)
                    resolve(resp)
                })
                .catch(err => {
                    localStorage.removeItem('user-token')
                    localStorage.removeItem('refresh-token')
                    localStorage.removeItem('remember-me')
                    reject(err)
                })
        })
    },
    getLoginData({ commit }) {
        if (localStorage.getItem('login-info') !== null) {
            commit("SET_LOGININFO", JSON.parse(localStorage.getItem('login-info')))
        } else {
            commit("SET_LOGININFO", {
                user: {
                    "username": "",
                    "name": ""
                }
            })
        }
    },
    getDiscountTypes({ commit }) {
        axios.get('/discounts')
            .then(response => {
                commit('SET_DISCOUNTS', response.data)
            }).catch(function () {

            })
    },
    getPaymentMethods({ commit }) {
        axios.get('/paymentmethods')
            .then(response => {
                commit('SET_PAYMENTMETHODS', response.data)
            }).catch(function () {

            })
    },
    getRestAreas({ commit }) {
        axios.get('/restaurant/areas')
            .then(response => {
                commit('SET_RESTAREAS', response.data)
            }).catch(function () {

            })
    },
    getRestAreasLabels({ commit }) {
        axios.get('/restaurant/areas/labels')
            .then(response => {
                commit('SET_RESTAREASLABELS', response.data)
            }).catch(function () {

            })
    },
    getProducts({ commit }) {
        axios.get('/products')
            .then(response => {
                commit('SET_PRODUCTS', response.data)
            })
    },
    getActivetickets({ commit }) {
        axios.get('/tickets/active')
            .then(response => {
                commit('SET_ACTIVETICKETS', response.data)
            })
    },
    getGroups({ commit }) {
        axios.get('/groups')
            .then(response => {
                commit('SET_GROUPS', response.data)
            })
    },
    setActualTicket({ commit }, ticektId) {
        commit("SET_ACTIVE_TICKET", ticektId)
    }
};

const mutations = {
    SET_PAYMENTMETHODS(state, paym) { state.paymentMethods = paym },
    SET_ACTIVE_TICKET(state, ticketId) { state.actualTicket = ticketId },
    SET_DISCOUNTS(state, discounts) { state.discount_types = discounts },
    SET_LOGININFO(state, info) { state.loginInfo = info },
    SET_PRODUCTS(state, products) {
        state.products = products
    },
    SET_GROUPS(state, groups) {
        state.groups = groups
    },
    SET_ACTIVETICKETS(state, tickets) {
        state.activeTickets = tickets
    },
    SET_RESTAREAS(state, areas) { state.restaurantAreas = areas },
    SET_RESTAREASLABELS(state, areas) { state.restAreaLabels = areas },
    AUTH_REQUEST: (state) => {
        state.status = 'loading'
    },
    AUTH_SUCCESS: (state, token) => {
        state.status = 'success'
        state.token = token
    },
    SET_REFRESH_TOKEN: (state, refreshToken) => {
        state.refreshToken = refreshToken
    },
    AUTH_ERROR: (state) => {
        state.status = 'error'
    },
    LOGOUT: (state) => {
        state.status = ''
        state.token = ''
        state.refreshToken = ''
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};